import * as Msal from "@azure/msal-browser";
import { AppConstants } from '../../../common/APIConstants';
export class AuthenticationService {
    constructor() {
        this.clientApplication = new Msal.PublicClientApplication({
            auth: {
                clientId: AppConstants.APP_CLIENT_ID,
                redirectUri: AppConstants.REDIRECT_URI,
                postLogoutRedirectUri: AppConstants.POST_LOGOUT_REDIRECT_URI,
                authority: AppConstants.AUTHORITY
            },
            cache: {
                cacheLocation: 'sessionStorage'
            }
        });
    }
    async acquireTokenSilent(scope) {
        const loginRequest = {
            client_id: AppConstants.APP_CLIENT_ID,
            grant_type: AppConstants.API_GRANT_TYPE,
            resource: AppConstants.APP_CLIENT_ID,
            redirect_uri: AppConstants.REDIRECT_URI,
            scopes: scope.scopes
        };
        const clientApplication = this.clientApplication;
        const idToken = await clientApplication.acquireTokenSilent(loginRequest);
        return Promise.resolve({
            value: idToken.accessToken === '' || idToken.accessToken === null
                ? idToken.idToken
                : idToken.accessToken,
            userName: idToken.account.username,
            displayName: idToken.account.name,
            expiry: idToken.expiresOn,
            roles: this.getUserRoles(idToken.account.idTokenClaims.roles)
        });
    }
    async acquireTokenPopup(scope) {
        const loginRequest = {
            client_id: AppConstants.APP_CLIENT_ID,
            grant_type: AppConstants.API_GRANT_TYPE,
            resource: AppConstants.APP_CLIENT_ID,
            redirect_uri: AppConstants.REDIRECT_URI,
            scopes: scope.scopes
        };
        const clientApplication = this.clientApplication;
        const idToken = await clientApplication.acquireTokenPopup(loginRequest);
        clientApplication.setActiveAccount(idToken.account);
        return Promise.resolve({
            value: idToken.accessToken === '' || idToken.accessToken === null
                ? idToken.idToken.rawIdToken
                : idToken.accessToken,
            userName: idToken.account.username,
            displayName: idToken.account.name,
            expiry: idToken.expiresOn,
            roles: this.getUserRoles(idToken.idTokenClaims.roles)
        });
    }
    getUserRoles(roles) {
        let newRoles = [];
        if (roles && Array.isArray(roles)) {
            newRoles = roles;
        }
        return newRoles;
    }
    logout() {
        this.clientApplication.logout();
    }
    isOnline() {
        return this.clientApplication.getActiveAccount() != null;
    }
    getUser() {
        return this.clientApplication.getActiveAccount();
    }
}
export const authenticationService = new AuthenticationService();